module.exports = __webpack_public_path__ + "img/fringe-3in-bullion.08a7fc9b.png";